import { t as e } from "../utils-DiFe-_ei.js";
import { t } from "../dist-B6xjZgdF.js";
import "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/foundations/typography/typography.tsx
var r = {
	display: "p",
	"display-lg": "p",
	h1: "h1",
	h2: "h2",
	h3: "h3",
	h4: "h4",
	h5: "h5",
	h6: "h6",
	body: "p",
	"body-sm": "p",
	label: "span",
	caption: "p",
	overline: "p",
	code: "code"
}, i = {
	default: {},
	muted: { color: "var(--color-muted-foreground)" },
	primary: { color: "var(--color-primary)" },
	destructive: { color: "var(--color-destructive)" },
	"destructive-text": { color: "var(--color-destructive-text)" }
}, a = { fontFamily: "var(--font-display)" }, o = t("", {
	variants: { variant: {
		display: "font-black leading-[var(--leading-display)] tracking-[var(--tracking-display)] [font-size:var(--text-display)]",
		"display-lg": "font-black leading-[var(--leading-display)] tracking-[var(--tracking-display)] [font-size:var(--text-h1)] sm:[font-size:2.25rem] md:[font-size:var(--text-display-lg)]",
		h1: "font-bold leading-[var(--leading-heading)] tracking-[var(--tracking-heading)] [font-size:var(--text-h1)]",
		h2: "font-bold leading-[var(--leading-heading)] tracking-[var(--tracking-heading)] [font-size:var(--text-h2)]",
		h3: "font-semibold leading-[var(--leading-heading)] tracking-[var(--tracking-heading)] [font-size:var(--text-h3)]",
		h4: "font-semibold leading-[var(--leading-heading)] tracking-[var(--tracking-heading-sm)] [font-size:var(--text-h4)]",
		h5: "font-semibold leading-[var(--leading-body)] [font-size:var(--text-h5)]",
		h6: "font-semibold leading-[var(--leading-body)] [font-size:var(--text-h6)]",
		body: "font-normal leading-[var(--leading-body)] [font-size:var(--text-body)]",
		"body-sm": "font-normal leading-[var(--leading-body)] [font-size:var(--text-body-sm)]",
		label: "font-medium leading-[var(--leading-body)] [font-size:var(--text-label)]",
		caption: "font-medium leading-[var(--leading-body)] [font-size:var(--text-caption)]",
		overline: "font-medium uppercase leading-[var(--leading-body)] tracking-[var(--tracking-overline)] [font-size:var(--text-overline)]",
		code: "rounded bg-muted px-1 font-normal leading-[var(--leading-body)] [font-size:var(--text-body-sm)] [font-family:var(--font-mono)]"
	} },
	defaultVariants: { variant: "body" }
});
function s({ as: t, variant: s = "body", color: c = "default", truncate: l, className: u, style: d, ...f }) {
	let p = t ?? r[s], m = {
		...s === "display" || s === "display-lg" ? a : {},
		...i[c],
		...d
	};
	return /* @__PURE__ */ n(p, {
		className: e(o({ variant: s }), l && "truncate", u),
		style: Object.keys(m).length > 0 ? m : void 0,
		...f
	});
}
//#endregion
export { s as Typography };

//# sourceMappingURL=typography.js.map